import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackagesService {

  constructor(
    private http: HttpClient
  ) { }

  getPackages() {
    return (this.http.get(`${environment.apiUrl}/packaging`));
  }

  createPackage(data: any) {
    return (this.http.post(`${environment.apiUrl}/packaging`, data));
  }

  updatePackage(data: any) {
    return (this.http.put(`${environment.apiUrl}/packaging/${data.id}`, data));
  }

  deletePackage(id: number) {
    return (this.http.delete(`${environment.apiUrl}/packaging/${id}`));
  }


}
